<template>
  <Listbox as="div" v-model="selected" v-if="index.length > 0">
    <ListboxLabel class="block text-sm font-medium text-gray-700">Store</ListboxLabel>
    <div class="relative mt-1">
      <ListboxButton
        class="relative w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-xs focus:border-primary focus:outline-hidden focus:ring-1 focus:ring-primary sm:text-sm"
      >
        <span class="block truncate">{{ storeDisplayableName(selected) }}</span>
        <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
          <ChevronDownIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
        </span>
      </ListboxButton>
      <transition
        leave-active-class="transition ease-in duration-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ListboxOptions
          class="absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-hidden sm:text-sm"
        >
          <ListboxOption
            as="template"
            v-for="store in index"
            :key="store.id"
            :value="store"
            v-slot="{ active, selected }"
          >
            <li
              :class="[
                active ? 'text-white bg-primary' : 'text-gray-900',
                'relative cursor-default select-none py-2 pl-3 pr-9',
              ]"
            >
              <span :class="[selected ? 'font-semibold' : 'font-normal', 'block truncate']">
                {{ storeDisplayableName(store) }}
              </span>
              <span
                v-if="selected"
                :class="[
                  active ? 'text-white' : 'text-primary-dark',
                  'absolute inset-y-0 right-0 flex items-center pr-4',
                ]"
              >
                <CheckIcon class="h-5 w-5" aria-hidden="true" />
              </span>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script>
import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions } from "@headlessui/vue";
import { CheckIcon, ChevronDownIcon } from "@heroicons/vue/outline";
import { mapActions, mapMutations, mapState } from "vuex";
import { isObjectValid } from "@estaly/ui";

export default {
  components: {
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    ChevronDownIcon,
  },
  data() {
    return {
      defaultSelectedValue: { id: null, salesChannel: "Choose a store" },
    };
  },

  async created() {
    await this.fetchStores({
      perPage: 2000,
      status: ["active"],
      source: ["shopify", "magento1", "magento2", "prestashop", "api"],
    });
    if (this.index.length === 1) this.selected = this.index[0];
  },

  computed: {
    ...mapState("stores", ["index"]),
    ...mapState("products", ["selectedStore"]),

    selected: {
      get() {
        return this.selectedStore || this.defaultSelectedValue;
      },
      set(option) {
        if (isObjectValid(option) && option.value !== null) {
          this.setSelectedStore(option);
          this.$emit("updatedSelectedStore");
        }
      },
    },
  },
  methods: {
    ...mapActions("stores", { fetchStores: "fetchIndex" }),
    ...mapMutations("products", ["setSelectedStore"]),

    storeDisplayableName(store) {
      return store.salesChannel || `Store ${store.id}`;
    },
  },
};
</script>
